import React from "react";
import { Row, Col } from "reactstrap";

import { ReactComponent as LitigantSvg } from "./images/002-support.svg";
import { ReactComponent as AttorneysSvg } from "./images/001-employee.svg";
import { ReactComponent as EmailSvg } from "./images/003-email.svg";

const TopMenu = props => {
  return (
    <Row className="pr-0 pl-0 topMenu">
      <Col>
        <Row
          className="text-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Col xs={4}>
            <props.ScrollLink
              activeClass="active"
              to="litigants"
              spy={true}
              smooth={true}
              duration={500}
            >
              <LitigantSvg className="topMenuIcon" />
              <span className="menuItem align-bottom">Litigants</span>
            </props.ScrollLink>
          </Col>
          <Col xs={4}>
            <props.ScrollLink
              activeClass="active"
              to="attorneys"
              spy={true}
              smooth={true}
              duration={500}
            >
              <AttorneysSvg className="topMenuIcon" />
              <span className="menuItem align-bottom">Attorneys</span>
            </props.ScrollLink>
          </Col>
          <Col xs={4}>
            <props.ScrollLink
              activeClass="active"
              to="contactUs"
              spy={true}
              smooth={true}
              duration={500}
            >
              <EmailSvg className="topMenuIcon" />
              <span className="menuItem align-bottom">Contact us</span>
            </props.ScrollLink>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default TopMenu;
